import { PlusOutlined } from '@ant-design/icons';

import { Flex } from '@/components/base';
import Tooltip from '@/components/Tooltip/TooltipV2';
import BookmarkItem from '@/features/Bookmark/BookmarkItem';
import useUserRole from '@/hooks/domain/useUserRole';

import IconButton from '../../components/Button/IconButton';

interface Props {
  bookmarkList?: BookmarkT[];
  setBookmarkModalStatus?: (state: BookmarkModalState) => void;
}

export type BookmarkModalState = {
  status: boolean;
  action: BookmarkStatusT;
  target: string;
};

const Bookmark = ({ bookmarkList, setBookmarkModalStatus }: Props) => {
  const { isEditor } = useUserRole();

  return (
    <Flex g="4px" a="center" style={{ maxWidth: 400, flexWrap: 'wrap' }}>
      {bookmarkList?.map((bookmark) => (
        <BookmarkItem
          key={bookmark.name}
          {...bookmark}
          setBookmarkModalStatus={setBookmarkModalStatus}
        />
      ))}
      {isEditor && setBookmarkModalStatus && (
        <div style={{ position: 'relative' }}>
          <Tooltip tooltipNode="Add design or PRD links">
            <IconButton
              icon={<PlusOutlined />}
              sizeType="s"
              outlined={false}
              onClick={() =>
                setBookmarkModalStatus({
                  status: true,
                  action: 'add',
                  target: '',
                })
              }
            />
          </Tooltip>
        </div>
      )}
    </Flex>
  );
};

export default Bookmark;
